import GuidedError from './GuidedError';

export default GuidedError;
